import { useCallback, useState, useRef, useEffect } from 'react';
import { useWindowDimensions, Dimensions } from 'react-native';

const MB_utilHooks = {
  useBool: (initialValue = false): [boolean, () => void, () => void] => {
    const [state, setState] = useState<boolean>(initialValue);
    const setTrue = useCallback(() => setState(true), []);
    const setFalse = useCallback(() => setState(false), []);
    return [state, setTrue, setFalse];
  },
  useWidthChange: (isActive: boolean, callBack: () => void) => {
    const dims = useWindowDimensions();
    const windowWidth = useRef(dims.width);

    // We need to set the width when window gets activated, otherwise if you change the window width and
    // then mount this, callback will get called.
    useEffect(() => {
      if (isActive) {
        windowWidth.current = Dimensions.get('window').width;
      }
    }, [isActive]);

    useEffect(() => {
      if (!isActive) {
        return;
      }

      if (dims.width !== windowWidth.current) {
        callBack();
        windowWidth.current = dims.width;
      }
    }, [callBack, dims.width, isActive]);
  },
};

export { MB_utilHooks };
